/* eslint-disable */
require('es5-shim');
import 'es5-shim/es5-sham';
import 'core-js/fn/object/assign';
require('es6-promise/auto');
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import configureStore from './store/configureStore';
import getRoutes from './routes';
/* eslint-enable */

const store = configureStore(hashHistory);

const history = syncHistoryWithStore(hashHistory, store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} routes={getRoutes()} />
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./app/main.js